<template>
  <div class="overflow-auto p-4 sm:p-6">
    <BaseCard class="w-full max-w-lg mx-auto">
      <div class="px-12 py-10">
        <h2 class="text-lg text-center font-bold text-blue-600 mb-8">Thanks for registering!</h2>
        <p class="text-sm text-gray-600 text-center mb-4">
          Before getting started, could you verify your email address by clicking on the link we
          just emailed to you? If you didn't receive the email, we will gladly send you another.
        </p>
        <p class="text-sm text-blue-600 font-medium text-center">
          A new verification link has been sent to the email address you provided during
          registration.
        </p>
      </div>
      <div class="px-12 py-10 bg-gray-50 flex flex-col space-y-4">
        <BaseButton primary @click="onResendVerificationEmail">
          Resend Verification Email
        </BaseButton>
        <BaseButton primary outline tag="router-link" to="/logout" class="text-center">
          Logout
        </BaseButton>
      </div>
    </BaseCard>
  </div>
</template>

<script>
export default {
  methods: {
    async onResendVerificationEmail() {
      try {
        await this.$store.dispatch('ui/auth/sendEmailVerificationNotice');
      } catch (error) {
        //
      }
    },
  },
};
</script>
